import { Component, inject, OnInit, OnDestroy, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface PdfViewerDialogData {
  url?: string;
  pdfData?: ArrayBuffer;
}

@Component({
  selector: 'app-pdf-viewer-dialog',
  standalone: true,
  imports: [],
  templateUrl: './pdf-viewer.component.html'
})
export class PdfViewerDialogComponent implements OnInit, OnDestroy {
  public readonly data = inject<PdfViewerDialogData>(MAT_DIALOG_DATA);
  private readonly sanitizer = inject(DomSanitizer);

  safeUrl = signal<SafeResourceUrl | null>(null);
  private blobUrl: string | null = null;

  ngOnInit(): void {
    if (this.data.url) {
      this.safeUrl.set(this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url));
    } else if (this.data.pdfData) {
      const blob = new Blob([this.data.pdfData], { type: 'application/pdf' });
      this.blobUrl = URL.createObjectURL(blob);
      this.safeUrl.set(this.sanitizer.bypassSecurityTrustResourceUrl(this.blobUrl));
    }
  }

  ngOnDestroy(): void {
    if (this.blobUrl) {
      URL.revokeObjectURL(this.blobUrl);
    }
  }
}
